module.exports = __webpack_public_path__ + "img/36_74.0005a5a3.png";